// Cada app deve ter seu ITenant definido
// TODO: Verificar como as referências poderiam ser direcionadas
// ao tenant do app
export interface ITenant {
    [key: string]: any;
}